import { all, fork } from 'redux-saga/effects';
import * as W from './watchers';

export function* webhooksSaga() {
  yield all([
    fork(W.watchGetWebhooks),
    fork(W.watchGetWebhookById),
    fork(W.watchCreateWebhook),
    fork(W.watchUpdateWebhook),
    fork(W.watchDeleteWebhook),
    fork(W.watchTestWebhook),
  ]);
}
